import { render, staticRenderFns } from "./CohortSimulationCompetenciesPage.vue?vue&type=template&id=ef4fe3cc"
import script from "./CohortSimulationCompetenciesPage.vue?vue&type=script&lang=js"
export * from "./CohortSimulationCompetenciesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports